import { render, staticRenderFns } from "./ModalCommissionConfig.vue?vue&type=template&id=631207f0&lang=pug&"
import script from "./ModalCommissionConfig.vue?vue&type=script&lang=js&"
export * from "./ModalCommissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalCommissionConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports